export const VIEWBEAN_URL = '/bean/getViewBeans.action?beans=OriginViewBean';
export const REQUEST_TIMEOUT = 840000; // 14 minutes
export const LAST_REQUEST_KEY_NAME = 'ah-date-last-request';
export const SESSION_ID_COOKIE_NAME = 'JSESSIONID';
